/**
 * Lightweight reactive store — replaces sessionStorage-driven state.
 * Use Vue.observable so any component referencing this will re-render on change.
 */
import Vue from 'vue';

const state = Vue.observable({
  // User auth
  token: localStorage.getItem('token') || '',
  userinfo: (function () {
    try { return JSON.parse(localStorage.getItem('userinfo') || 'null') || {}; }
    catch (_) { return {}; }
  })(),

  // Location
  userLocation: sessionStorage.getItem('userLocation') || '洛杉矶',
  locationEnabled: sessionStorage.getItem('locationEnabled') || '',
  nearbyRange: sessionStorage.getItem('nearbyRange') || null,

  // Identity verify
  identityVerifyStatus: sessionStorage.getItem('identityVerifyStatus') || '',

  // Navigation params (short-lived, wiped after use)
  activeUserId: '',
  activeGoodsId: '',
  activeHelpId: '',
  activeGuideId: '',
  activeBrowseCategory: '',
  activeMessageId: '',

  // Dirty flags
  wantedListDirty: false
});

const store = {
  state,

  // ── Auth ──
  setToken(token) {
    state.token = token;
    localStorage.setItem('token', token);
  },
  setUserinfo(info) {
    state.userinfo = Object.assign({}, state.userinfo, info);
    localStorage.setItem('userinfo', JSON.stringify(state.userinfo));
  },
  clearAuth() {
    state.token = '';
    state.userinfo = {};
    state.identityVerifyStatus = '';
    state.activeUserId = '';
    state.activeGoodsId = '';
    state.activeHelpId = '';
    state.activeGuideId = '';
    state.activeBrowseCategory = '';
    state.activeMessageId = '';
    state.wantedListDirty = false;
    localStorage.removeItem('token');
    localStorage.removeItem('userinfo');
    localStorage.removeItem('currentUserProfile');
    localStorage.removeItem('myFavorites');
    localStorage.removeItem('myFollows');
    localStorage.removeItem('myProducts');
    localStorage.removeItem('myWantedPosts');
    localStorage.removeItem('lastPublished');
    localStorage.removeItem('readMessages');
    sessionStorage.removeItem('identityVerifyStatus');
    sessionStorage.removeItem('identityVerifyData');
    sessionStorage.removeItem('userPassword');
    sessionStorage.removeItem('activeUserId');
    sessionStorage.removeItem('activeGoodsId');
    sessionStorage.removeItem('activeHelpId');
    sessionStorage.removeItem('activeGuideId');
    sessionStorage.removeItem('activeBrowseCategory');
    sessionStorage.removeItem('activeMessageId');
    sessionStorage.removeItem('activeMessagePayload');
    sessionStorage.removeItem('editingGoodsId');
    sessionStorage.removeItem('userProfileBack');
    sessionStorage.removeItem('wantedListDirty');
  },
  get isLoggedIn() {
    return !!state.token;
  },

  // ── Location ──
  setLocation(label) {
    state.userLocation = label;
    state.locationEnabled = 'true';
    sessionStorage.setItem('userLocation', label);
    sessionStorage.setItem('locationEnabled', 'true');
  },

  // ── Identity verify ──
  setIdentityVerifyStatus(status) {
    state.identityVerifyStatus = status;
    sessionStorage.setItem('identityVerifyStatus', status);
  },
  get isIdentityVerified() {
    return state.identityVerifyStatus === 'approved';
  },

  // ── Nav params (write-once, read idempotent) ──
  setActiveUserId(id) { state.activeUserId = id; sessionStorage.setItem('activeUserId', id); },
  setActiveGoodsId(id) { state.activeGoodsId = id; sessionStorage.setItem('activeGoodsId', id); },
  setActiveHelpId(id) { state.activeHelpId = id; sessionStorage.setItem('activeHelpId', id); },
  setActiveGuideId(id) { state.activeGuideId = id; sessionStorage.setItem('activeGuideId', id); },
  setActiveBrowseCategory(cat) { state.activeBrowseCategory = cat; sessionStorage.setItem('activeBrowseCategory', cat); },
  setActiveMessageId(id) { state.activeMessageId = id; sessionStorage.setItem('activeMessageId', id); },

  // ── Dirty flags ──
  markWantedListDirty() {
    state.wantedListDirty = true;
    sessionStorage.setItem('wantedListDirty', 'true');
  },
  clearWantedListDirty() {
    state.wantedListDirty = false;
    sessionStorage.removeItem('wantedListDirty');
  }
};

export default store;
